import { render, staticRenderFns } from "./VcitaDialog.vue?vue&type=template&id=91af5406&scoped=true"
import script from "./VcitaDialog.vue?vue&type=script&lang=js"
export * from "./VcitaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91af5406",
  null
  
)

export default component.exports